import React from 'react';
import classNames from 'classnames';

const MenuItems = React.forwardRef(({ pullRight, className, children, ...remainingProps }, ref) => {
    const dropdownMenuClasses = classNames('dropdown-menu', pullRight && 'pull-right', className);

    return (
        <ul {...remainingProps} className={dropdownMenuClasses} ref={ref} role={'menu'}>
            {children}
        </ul>
    );
});

export default MenuItems;
